/**
 * Resolves the dynamic public site URL for a given profile subdomain or custom domain.
 * Adapts to local development, staging workers.dev, and production profolio.lk custom domains.
 */
export function getPublicSiteUrl(subdomain?: string | null, customDomain?: string | null): string {
  if (customDomain) {
    return customDomain.startsWith("http://") || customDomain.startsWith("https://")
      ? customDomain
      : `https://${customDomain}`;
  }
  if (!subdomain) return "#";

  const publicSiteDomain =
    typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_PUBLIC_SITE_DOMAIN &&
    import.meta.env.VITE_PUBLIC_SITE_DOMAIN !== "profolio.lk"
      ? import.meta.env.VITE_PUBLIC_SITE_DOMAIN
      : "profolio-renderer.dresser-manager.workers.dev";

  const isWorkersDev = publicSiteDomain.includes("workers.dev");
  return isWorkersDev
    ? `https://${publicSiteDomain}/p/${subdomain}`
    : `https://${subdomain}.${publicSiteDomain}`;
}

/**
 * Returns a human-friendly domain string for displaying in badges and pills.
 */
export function getDisplayDomain(subdomain?: string | null, customDomain?: string | null): string {
  if (customDomain) {
    return customDomain.replace(/^https?:\/\//, "");
  }
  if (!subdomain) return "";

  const publicSiteDomain =
    typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_PUBLIC_SITE_DOMAIN &&
    import.meta.env.VITE_PUBLIC_SITE_DOMAIN !== "profolio.lk"
      ? import.meta.env.VITE_PUBLIC_SITE_DOMAIN
      : "profolio-renderer.dresser-manager.workers.dev";

  const isWorkersDev = publicSiteDomain.includes("workers.dev");
  return isWorkersDev
    ? `${publicSiteDomain}/p/${subdomain}`
    : `${subdomain}.${publicSiteDomain}`;
}

/**
 * Resolves the permanent public CV URL for a given profile.
 * Unlike temporary generation tokens, this link is directly anchored to the
 * user's profile and remains constant across all content edits and re-generations.
 */
export function getPublicCVUrl(subdomain?: string | null, customDomain?: string | null): string {
  if (customDomain) {
    const cleanDomain = customDomain.replace(/^https?:\/\//, "").replace(/\/+$/, "");
    return `https://${cleanDomain}/cv.pdf`;
  }
  if (!subdomain) return "#";

  const publicSiteDomain =
    typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_PUBLIC_SITE_DOMAIN &&
    import.meta.env.VITE_PUBLIC_SITE_DOMAIN !== "profolio.lk"
      ? import.meta.env.VITE_PUBLIC_SITE_DOMAIN
      : "profolio-renderer.dresser-manager.workers.dev";

  const isWorkersDev = publicSiteDomain.includes("workers.dev");
  return isWorkersDev
    ? `https://${publicSiteDomain}/p/${subdomain}/cv.pdf`
    : `https://${subdomain}.${publicSiteDomain}/cv.pdf`;
}
